import { useMemo } from "react";

import { useColor } from "@braze/beacon-styling";

export const useLiquidThemeConfig = () => {
  const getColor = useColor();
  return useMemo(
    () => ({
      base: "vs",
      inherit: true,
      colors: {},
      rules: [
        {
          foreground: getColor("fuschia", 400),
          token: "delimiter.output.liquid",
        },
        {
          foreground: getColor("fuschia", 400),
          token: "delimiter.tag.liquid",
        },
        {
          foreground: getColor("lightGreen", 500),
          fontStyle: "bold",
          token: "braze.liquid.attribute",
        },
        {
          foreground: getColor("fuschia", 500),
          fontStyle: "bold",
          token: "braze.liquid.namespace",
        },
        // COMPI-1808: When the new braze color is ready, replace the hard coded color to braze color
        { foreground: "#FF0F1C", fontStyle: "bold", token: "braze.liquid.abortMessage" },
        {
          foreground: getColor("lightBlue", 500),
          fontStyle: "bold",
          token: "braze.liquid.connectedContent",
        },
        {
          foreground: getColor("gray", 800),
          token: "predefined.liquid",
        },
        {
          foreground: "#0009F7",
          token: "string.liquid",
        },
        {
          foreground: "#0009F7",
          token: "number.liquid",
        },
        { foreground: "#0009F7", token: "variable.liquid" },
      ],
    }),
    [getColor]
  );
};
